<script>
let ssoUrl = ''
let apiUrl = ''
let tsApiUrl = ''
let portalUrl = ''
let jobUrl = ''
let tsUrl = ''
let hfUrl = ''
let reportUrl = ''
let modelUrl = ''
let judgeComplaintPriGuid = '' //举报投诉线索分配
let distrComplaintPriGuid = '' //举报投诉线索关闭（监察部长才具备）
let auditUrl = ''

let bsOfficeHost = ''
let httpXy = ''

let dev = ''

console.log(process.env.NODE_ENV)
let fsAppId = ''
switch (process.env.NODE_ENV) {
  case 'development':
    httpXy = 'http'
    ssoUrl = 'http://dev-sso-audit.sany.com.cn'
    tsApiUrl = 'http://dev-api-audit.sany.com.cn:8001'
    apiUrl = 'http://dev-api-audit.sany.com.cn:8001'
    portalUrl = 'http://dev-portal-audit.sany.com.cn'
    jobUrl = 'http://dev-job-audit.sany.com.cn'
    tsUrl = 'http://dev-api-audit.sany.com.cn'
    hfUrl = 'http://dev-hf-audit.sany.com.cn'
    reportUrl = 'http://dev-report-audit.sany.com.cn'
    modelUrl = 'http://dev-model-audit.sany.com.cn'
    judgeComplaintPriGuid = 'f2d3794e12e34ed4b5c3f92298a896aa'
    distrComplaintPriGuid = '5384ac6534be4ba085a2d0f67bd59402'
    // 三一飞书
    fsAppId = 'cli_a3ab287e71b89077'
    // saas飞书
    //fsAppId = 'cli_aab63099dffa1bcd'
    bsOfficeHost = 'https://one-transfile.sany.com.cn'
    auditUrl = 'http://dev-audit.sany.com.cn'

    dev = 'dev-'
    break
  case 'dev':
    httpXy = 'https'
    ssoUrl = 'https://dev-sso-audit.sany.com.cn'
    apiUrl = 'https://dev-api-audit.sany.com.cn'
    portalUrl = 'https://dev-portal-audit.sany.com.cn'
    jobUrl = 'https://dev-job-audit.sany.com.cn'
    tsUrl = 'https://dev-api-audit.sany.com.cn'
    hfUrl = 'https://dev-hf-audit.sany.com.cn'
    reportUrl = 'https://dev-report-audit.sany.com.cn'
    modelUrl = 'https://dev-model-audit.sany.com.cn'
    judgeComplaintPriGuid = 'f2d3794e12e34ed4b5c3f92298a896aa'
    distrComplaintPriGuid = '5384ac6534be4ba085a2d0f67bd59402'
    // 三一飞书
    fsAppId = 'cli_a3ab287e71b89077'
    // saas飞书
    //fsAppId = 'cli_aab63099dffa1bcd'
    bsOfficeHost = 'https://one-transfile.sany.com.cn'
    auditUrl = 'https://dev-audit.sany.com.cn'

    dev = 'dev-'
    break
  case 'production':
    httpXy = 'https'
    ssoUrl = 'https://sso-audit.sany.com.cn'
    tsApiUrl = 'https://api-audit.sany.com.cn'
    apiUrl = 'https://api-audit.sany.com.cn'
    portalUrl = 'https://portal-audit.sany.com.cn'
    jobUrl = 'https://job-audit.sany.com.cn'
    tsUrl = 'https://api-audit.sany.com.cn'
    hfUrl = 'https://hf-audit.sany.com.cn'
    reportUrl = 'https://report-audit.sany.com.cn'
    modelUrl = 'https://model-audit.sany.com.cn'
    judgeComplaintPriGuid = 'aeef16f511414a28a55a35072ccabb69'
    distrComplaintPriGuid = '196254e9c7d94b26897a7e585892e1cd'
    fsAppId = 'cli_a197b9174478d077'
    bsOfficeHost = 'https://one-transfile.sany.com.cn'
    auditUrl = 'https://audit.sany.com.cn'
    dev = ''
    break
}
export default {
  httpXy,
  ssoUrl,
  apiUrl,
  tsApiUrl,
  portalUrl,
  jobUrl,
  tsUrl,
  hfUrl,
  reportUrl,
  modelUrl,
  judgeComplaintPriGuid,
  distrComplaintPriGuid,
  fsAppId,
  dev,
  auditUrl,
  bsOfficeHost,
}
</script>
